import React, { useRef, useState } from "react";
import ReactDOM from "react-dom";
import executeRequest from "../../modules/request.js";
import LoadingComponent from "../../shared/ui/animations/loading.js";
import Checkbox from "../../shared/ui/inputs/checkbox.js";
import Button from "../../shared/ui/inputs/classicButton.js";
import "../../../../shared/styles/colorDefinitions.css";
import "../../style.css";
import "../../../../shared/styles/buttonStyles.css";
import AccountCreated from "./accountCreated.js";
function Container(props) {
    var _a;
    const form = useRef(null);
    const [isCheckboxChecked, setChecked] = useState(false);
    const [loading, setLoading] = useState(false);
    const inputs = {
        name: useRef(null),
        email: useRef(null),
        phone: useRef(null),
        password: useRef(null),
    };
    const [isInputNameCorrect, setInputNameCorrect] = useState("");
    const [isInputEmailCorrect, setInputEmailCorrect] = useState("");
    const [isInputPhoneCorrect, setInputPhoneCorrect] = useState("");
    const [isinputPasswordCorrect, setInputPasswordCorrect] = useState("");
    const [isCheckboxCorrect, setCheckboxCorrect] = useState("");
    const setters = {
        name: setInputNameCorrect,
        email: setInputEmailCorrect,
        phone: setInputPhoneCorrect,
        password: setInputPasswordCorrect,
    };
    async function submitForm() {
        var _a, _b, _c, _d, _e, _f, _g;
        setCheckboxCorrect("");
        if (!isCheckboxChecked) {
            setCheckboxCorrect("To pole jest wymagane");
            return;
        }
        const data = {
            name: (_a = inputs.name.current) === null || _a === void 0 ? void 0 : _a.value,
            email: (_b = inputs.email.current) === null || _b === void 0 ? void 0 : _b.value,
            phone: (_c = inputs.phone.current) === null || _c === void 0 ? void 0 : _c.value,
            password: (_d = inputs.password.current) === null || _d === void 0 ? void 0 : _d.value,
        };
        setLoading(true);
        const res = await executeRequest("/api/public/users/createAccount", "POST", data);
        setLoading(false);
        for (const inputName in inputs) {
            (_e = inputs[inputName].current) === null || _e === void 0 ? void 0 : _e.setAttribute("data-isincorrect", "false");
            (_f = setters[inputName]) === null || _f === void 0 ? void 0 : _f.call(setters, "");
        }
        if (res.status == 400) {
            res.invalidParams.forEach((paramName) => {
                var _a, _b, _c, _d;
                (_b = (_a = form === null || form === void 0 ? void 0 : form.current) === null || _a === void 0 ? void 0 : _a.querySelector(`#input_${paramName}`)) === null || _b === void 0 ? void 0 : _b.setAttribute("data-isincorrect", "true");
                if (paramName == "password") {
                    (_c = setters[paramName]) === null || _c === void 0 ? void 0 : _c.call(setters, "Hasło musi składać się z przynajmniej 8 znaków");
                    return;
                }
                (_d = setters[paramName]) === null || _d === void 0 ? void 0 : _d.call(setters, "To pole jest wymagane");
            });
            return;
        }
        if (res.status == 409) {
            (_g = inputs.email.current) === null || _g === void 0 ? void 0 : _g.setAttribute("data-isincorrect", "true");
            setInputEmailCorrect("Ten adres email już jest w użyciu");
            return;
        }
        if (res.status == 200) {
            props.onSuccesfullCreation(data.email, data.password);
        }
    }
    if (props.isCreated) {
        return (React.createElement(React.Fragment, null,
            React.createElement(AccountCreated, { email: (_a = inputs.email.current) === null || _a === void 0 ? void 0 : _a.value })));
    }
    return (React.createElement("main", { className: "create_account-main landing-page-main" },
        React.createElement("div", { className: "create_account-container" },
            React.createElement("h2", null, "Tworzenie Konta fotografa"),
            React.createElement("form", { className: "create_account-form", ref: form, onSubmit: (event) => event.preventDefault() },
                React.createElement("label", null,
                    React.createElement("span", null,
                        "Imi\u0119 i nazwisko: ",
                        React.createElement("span", { className: "required" }, "*")),
                    React.createElement("input", { placeholder: "Podaj imi\u0119 i nazwisko", id: "input_name", ref: inputs.name }),
                    React.createElement("span", { className: "required" }, isInputNameCorrect)),
                React.createElement("label", null,
                    React.createElement("span", null,
                        "Adres e-mail: ",
                        React.createElement("span", { className: "required" }, "*")),
                    React.createElement("input", { placeholder: "Podaj adres email", id: "input_email", ref: inputs.email }),
                    React.createElement("span", { className: "required" }, isInputEmailCorrect)),
                React.createElement("label", null,
                    React.createElement("span", null,
                        "Numer telefonu: ",
                        React.createElement("span", { className: "required" }, "*")),
                    React.createElement("input", { placeholder: "Podaj numer telefonu", id: "input_phone", ref: inputs.phone }),
                    React.createElement("span", { className: "required" }, isInputPhoneCorrect)),
                React.createElement("label", null,
                    React.createElement("span", null,
                        "Has\u0142o: ",
                        React.createElement("span", { className: "required" }, "*")),
                    React.createElement("input", { placeholder: "Utw\u00F3rz has\u0142o", id: "input_password", type: "password", ref: inputs.password }),
                    React.createElement("span", { className: "required form-error" }, isinputPasswordCorrect)),
                React.createElement("label", { className: "flex-container-default" },
                    React.createElement(Checkbox, { onTrigger: setChecked }),
                    React.createElement("span", null,
                        "Akceptuj\u0119 ",
                        React.createElement("a", { href: "./statue.html" }, "Regulamin"),
                        React.createElement("br", null),
                        "oraz ",
                        React.createElement("a", { href: "./privacyPolicy.html" }, "Polityk\u0119 Prywatno\u015Bci"),
                        React.createElement("span", { className: "required" }, "*"))),
                React.createElement("span", { className: "required" }, isCheckboxCorrect),
                loading ?
                    React.createElement(LoadingComponent, { color: "classic", extraPadding: true })
                    : React.createElement(Button, { text: "Za\u0142\u00F3\u017C konto", value: "create_account", onClick: () => submitForm() }),
                React.createElement("span", null,
                    React.createElement("span", { className: "required" }, "*"),
                    " - Pole wymagane.")))));
}
function FormContainer() {
    const [isCreated, setCreated] = useState(false);
    return (React.createElement(React.Fragment, null,
        React.createElement(Container, { onSuccesfullCreation: async (email, pass) => {
                const res = await executeRequest(`/api/public/users/auth`, "POST", {
                    email,
                    pass,
                });
                setCreated(true);
            }, isCreated: isCreated })));
}
function Body() {
    return (React.createElement(React.Fragment, null,
        React.createElement(FormContainer, null)));
}
// eslint-disable-next-line react/no-deprecated
ReactDOM.render(Body(), document.body.querySelector("#container"));
